import { APPLICATION, Application } from '@lockton-apps/shared/util/constants';
import { InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { Client, Contact, Folder } from '@lockton-apps/shared/interfaces';
import { MOCKED_CLIENTS_DEFAULT } from './lib/clients.mock';
import { MocksService } from './lib/mocks.service';
import { MOCKED_CLIENT_CONTACTS_DEFAULT } from './lib/client-contacts.mock';
import { MOCKED_CLIENT_FOLDERS_DEFAULT } from './lib/client-folders.mock';

export { MocksService } from './lib/mocks.service';
export { MockedClientDefaultId } from './lib/clients.mock';

export const MOCKED_CLIENTS = new InjectionToken<Client[]>(
  'Current application clients mocks'
);

export const MOCKED_CLIENT_FOLDERS = new InjectionToken<
  Record<number, Folder[]>
>('Current application client folders mocks');

export const MOCKED_CLIENT_CONTACTS = new InjectionToken<
  Record<number, Contact[]>
>('Current application client contacts mocks');

export function provideMocks(isProduction: boolean) {
  if (isProduction) {
    return [];
  }

  return makeEnvironmentProviders([
    MocksService,
    createProvider(MOCKED_CLIENTS, (application: Application) => {
      switch (application) {
        case Application.ClientGateway:
          return MOCKED_CLIENTS_DEFAULT;

        case Application.Latam:
          return [];
      }
    }),
    createProvider(MOCKED_CLIENT_CONTACTS, (application: Application) => {
      switch (application) {
        case Application.ClientGateway:
          return MOCKED_CLIENT_CONTACTS_DEFAULT;

        case Application.Latam:
          return {};
      }
    }),
    createProvider(MOCKED_CLIENT_FOLDERS, (application: Application) => {
      switch (application) {
        case Application.ClientGateway:
          return MOCKED_CLIENT_FOLDERS_DEFAULT;

        case Application.Latam:
          return {};
      }
    }),
  ]);
}

function createProvider(
  token: InjectionToken<unknown>,
  factory: (application: Application) => unknown
) {
  return {
    provide: token,
    useFactory: factory,
    deps: [APPLICATION],
  };
}
